import type { RelativeWorkspacePath } from "@codesandbox/pitcher-client";
import { relativePathToResource } from "environment-interface";
import { useTextEditorModel } from "hooks/vscode/useTextEditorModel";
import { useEffect, useState } from "react";

import { MarkdownPreview } from "../common/MarkdownPreview/MarkdownPreview";

interface FileMarkdownPreviewProps {
  filepath: RelativeWorkspacePath;
}

export const FileMarkdownPreview: React.FC<FileMarkdownPreviewProps> = ({
  filepath,
}) => {
  const textEditorModel = useTextEditorModel(relativePathToResource(filepath));
  const [code, setCode] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (textEditorModel.state !== "READY") {
      return;
    }
    setCode(textEditorModel.model.textEditorModel.getValue());

    const onContentDisposer =
      textEditorModel.model.textEditorModel.onDidChangeContent(() => {
        setCode(textEditorModel.model.textEditorModel.getValue());
      });

    return () => {
      onContentDisposer.dispose();
    };
  }, [textEditorModel.state]);

  if (!code) {
    return null;
  }

  return <MarkdownPreview code={code} filepath={filepath} />;
};
